import Products from './products'
import ProductDetails from './productDetails'

export default [
    Products,
    ProductDetails
]